import React from 'react'

export default function Body() {
  return (
    <div>Body</div>
  )
}
